import axios from "axios";

export const api = axios.create({
    withCredentials: true,
    headers: {
        "Content-Type": "application/json",
    },
});

export class Api {
    static async get(endpoint: string): Promise<any> {
        return this.request(endpoint, "GET");
    }

    static async put(endpoint: string, body?: any): Promise<any> {
        return this.request(endpoint, "PUT", body);
    }

    static async post(endpoint: string, body?: any): Promise<any> {
        return this.request(endpoint, "POST", body);
    }

    static async putForm(endpoint: string, body?: any): Promise<any> {
        return this.formRequest(endpoint, "PUT", body);
    }

    static async postForm(endpoint: string, body?: any): Promise<any> {
        return this.formRequest(endpoint, "POST", body);
    }

    private static async request(endpoint: string, method: string, body?: any): Promise<any> {
        try {
            const response = await api({
                method: method,
                url: `api/${endpoint}`,
                data: body, // For POST and PUT, we use 'data' for request body
                validateStatus: (status) => true,
            });

            return this.handleResponse(response);
        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    }

    private static async formRequest(endpoint: string, method: string, body?: any): Promise<any> {
        try {
            const response = await api({
                method: method,
                url: `api/${endpoint}`,
                data: body, // Sending form data
                validateStatus: (status) => true,
                headers: {
                    "Content-Type": "multipart/form-data", // Adjust headers for form requests
                },
            });

            return this.handleResponse(response);
        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    }

    private static async handleResponse(response: any) {
        if (response.status === 200) {
            return response;
        }

        if (response.status === 401) {
            await this.renewAccessToken();
        }

        throw new Error(`API Error: ${response.status} - ${response.statusText}`);
    }

    private static async renewAccessToken() {
        try {
            const currentUrl = window.location.href;
            window.location.href = `https://wilcz.com/accounts?refresh=true&continue=${encodeURIComponent(currentUrl)}`; //TODO: url shouldn't be hardcoded
        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    }
}
